export default "__VITE_ASSET__D$fMFHJS__"